'use es6';

import { Fragment, Component } from 'react';
import identity from 'transmute/identity';
import PropTypes from 'prop-types';
import getErrorAlert from './ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.componentDidCatch = (error, errorInfo) => {
      getErrorAlert();
      this.props.onError(error, errorInfo);
      console.error(error, errorInfo);
    };
    this.render = () => {
      const {
        ErrorComponent,
        children
      } = this.props;
      const {
        hasError,
        error
      } = this.state;
      return hasError ? /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          "data-test-id": "error-boundary"
        }), /*#__PURE__*/_jsx(ErrorComponent, {
          error: error
        })]
      }) : children;
    };
    this.state = {
      hasError: false
    };
  }
}
ErrorBoundary.defaultProps = {
  children: null,
  onError: identity,
  ErrorComponent: () => null
};
ErrorBoundary.getDerivedStateFromError = error => {
  // Update state so the next render will show the fallback UI.
  return {
    hasError: true,
    error
  };
};
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  onError: PropTypes.func,
  ErrorComponent: PropTypes.elementType
};